import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import DomainList from '@/view/zone/domain/domainList.vue';
import DomainListFlat from '@/view/zone/domain/domainListFlat.vue';
import { getAllView } from '@/utils/viewinfo';
export default {
  components: {
    DomainList: DomainList,
    DomainListFlat: DomainListFlat
  },
  name: "DomainRR",
  data: function data() {
    return {
      listStyle: 0,
      adSearch: false,
      searchInfo: {
        searchMode: 0,
        domain: '',
        line: [],
        view: '',
        type: '',
        value: ''
      },
      qZone: this.$route.query.zone,
      selectedPrimaryDomain: false,
      isSticky: false,
      isCollapse: true,
      viewOptions: [],
      recorderType: [{
        label: this.$t('region.recordtype-annotation-a'),
        value: 'A'
      }, {
        label: this.$t('region.recordtype-annotation-aaaa'),
        value: 'AAAA'
      }, {
        label: this.$t('region.recordtype-annotation-cname'),
        value: 'CNAME'
      }, {
        label: this.$t('region.recordtype-annotation-mx'),
        value: 'MX'
      }, {
        label: this.$t('region.recordtype-annotation-txt'),
        value: 'TXT'
      }, {
        label: this.$t('region.recordtype-annotation-ns'),
        value: 'NS'
      }, {
        label: this.$t('region.recordtype-annotation-srv'),
        value: 'SRV'
      }, {
        label: this.$t('region.recordtype-annotation-caa'),
        value: 'CAA'
      }, {
        label: this.$t('region.recordtype-annotation-spf'),
        value: 'SPF'
      }, {
        label: this.$t('region.recordtype-annotation-naptr'),
        value: 'NAPTR'
      }]
    };
  },
  methods: {
    addDomain: function addDomain() {
      if (this.listStyle == 1) {
        this.$refs.domain_list_flat.addDomain();
      } else {
        this.$refs.domain_list.openDialog();
      }
    },
    onDelete: function onDelete() {
      if (this.listStyle == 1) {
        this.$refs.domain_list_flat.onDelete();
      } else {
        this.$refs.domain_list.onDelete();
      }
    },
    openImportDomainPage: function openImportDomainPage() {
      this.$router.push({
        name: "domainImport",
        query: {
          zone: this.qZone
        }
      });
    },
    onSubmit: function onSubmit() {
      if (this.searchInfo.line && this.searchInfo.line.length > 0) {
        this.searchInfo.view = this.searchInfo.line[this.searchInfo.line.length - 1];
      } else {
        this.searchInfo.view = "";
      }
      if (this.listStyle == 1) {
        this.$refs.domain_list_flat.onSubmit();
      } else {
        this.$refs.domain_list.onSubmit();
      }
    },
    paperScroll: function paperScroll(e) {
      if (e.target.localName == 'main') {
        var scroll_height = e.target.scrollTop;
        this.isSticky = scroll_height > 100;
        this.$bus.emit('scrollOffset', scroll_height);
      }
    },
    chooseViewMode: function chooseViewMode(viewModel) {
      if (this.listStyle == viewModel) {
        return;
      }
      this.listStyle = viewModel;
      window.localStorage.setItem('view_model', viewModel);
    },
    switchSearch: function switchSearch(isAdSearch) {
      console.log(this.searchInfo);
      this.searchInfo.searchMode = 0;
      this.searchInfo.domain = '';
      this.searchInfo.line = [];
      this.searchInfo.view = '';
      this.searchInfo.type = '';
      this.searchInfo.value = '';
      if (isAdSearch) {
        this.adSearch = true;
        if (this.viewOptions.length == 0) {
          this.viewOptions = getAllView(this.qZone);
        }
      } else {
        this.adSearch = false;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    window.addEventListener("scroll", this.paperScroll, true);
    this.$bus.on("collapse", function (item) {
      _this.isCollapse = item;
    });
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // 获取cooke
            _this2.listStyle = window.localStorage.getItem('view_model') || 0;
            _this2.$set(_this2.searchInfo, 'searchMode', 0);
            _this2.searchInfo.zone = _this2.$route.query.zone;
            if (_this2.$route.query.domain) {
              _this2.$set(_this2.searchInfo, 'domain', _this2.$route.query.domain);
              _this2.$set(_this2.searchInfo, 'searchMode', 1);
            }

            // 初始加载
            // Promise.all([store.dispatch('viewinfo/getTplMap'), store.dispatch('viewinfo/getRecordLines', this.$route.query.zone)]).then(()=>{ 
            //   this.viewOptions = getAllView(this.$route.query.zone)
            // }).catch((error) => {
            //   console.log(error)
            // })
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  destroyed: function destroyed() {
    //离开该页面需要移除这个监听的事件
    window.removeEventListener("scroll", this.paperScroll);
    // this.$bus.off('collapse')
  }
};